<template>
  <div class="container" id="profile_section">
    <div v-if="user_level < 90">
      <h5 class="text-danger text-center mt-5">Access Denied!</h5>
    </div>

    <div v-else>
      <div class="page-header gold mt-4 mb-2">
        <back-btn></back-btn>
        <h3 class="mb-0">
          <i class="fas fa-graduation-cap pr-1"></i>
          <small v-text="section_title"></small> (<small v-text="totalRows"></small>)
        </h3>
      </div>

      <div class="row mb-2">
        <div class="col-12 text-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="subsectionAdd">
            <i class="fas fa-graduation-cap"></i> Add New Lesson
          </button>
        </div>
      </div>

      <b-modal
        id="modal-subsection"
        :title="modal.title"
        ref="modal-subsection"
        no-close-on-backdrop
        size="lg"
      >
        <b-form @submit="submitSubsectionForm($event)">
          <b-form-group>
            <small class="text-muted">Section ID</small>
            <b-form-input
              v-model="modal.subsection.section_id"
              type="text"
              required
              readonly
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <small class="text-muted">Lesson Status</small>
            <b-form-select
              v-model="modal.subsection.status"
              :options="statuses"
              @change="validate(modal.subsection)"
            ></b-form-select>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Name</small>
            <b-form-input
              v-model="modal.subsection.title"
              type="text"
              required
              placeholder="Enter lesson name"
              @change="validate(modal.subsection)"
            ></b-form-input>
            <small class="text-danger" v-if="modal.subsection.title === ''">
              Enter a lesson name
            </small>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Sub Title</small>
            <b-form-input
              v-model="modal.subsection.sub_title"
              type="text"
              placeholder="Enter sub title"
              @change="validate(modal.subsection)"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Description</small>
            <b-form-textarea
              v-model="modal.subsection.description"
              type="text"
              required
              placeholder="Enter lesson description"
              rows="3"
              max-rows="6"
              @change="validate(modal.subsection)"
            ></b-form-textarea>
            <small class="text-danger" v-if="modal.subsection.description === ''">
              Enter a lesson description
            </small>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Main Text</small>
            <vue-editor v-model="modal.subsection.main_text"></vue-editor>
            <small class="text-danger" v-if="modal.subsection.main_text === ''">
              Enter the main text
            </small>
          </b-form-group>

          <b-form-group>
            <small class="text-muted"> Media - (URL to an MP3 or Youtube video) </small>

            <div v-if="modal.subsection.media">
              <div
                class="pb-1"
                v-for="(media, k) in modal.subsection.media"
                :key="'media_' + k"
              >
                <b-form-input
                  v-model="modal.subsection.media[k]"
                  type="text"
                  placeholder="Media URL"
                  @change="validate(modal.subsection)"
                ></b-form-input>
              </div>
              <small class="text-danger" v-if="modal.errors.media === ''">
                Enter a valid URL
              </small>
            </div>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Video Link</small>
            <b-form-input
              v-model="modal.subsection.video_link"
              type="text"
              placeholder="Enter video URL"
              @change="validate(modal.subsection)"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <small class="text-muted">Order</small>
            <b-form-input
              v-model="modal.subsection.sort"
              type="text"
              required
              placeholder="Sort Order"
              @change="validate(modal.subsection)"
            ></b-form-input>
            <small class="text-danger" v-if="modal.subsection.sort === ''">
              Enter sort order
            </small>
          </b-form-group>
        </b-form>

        <p><small class="text-danger" v-text="modal.errors.process"></small></p>

        <template #modal-footer="{ cancel }">
          <div class="w-100 row">
            <div class="col text-left">
              <b-button
                type="button"
                size="md"
                variant="success"
                :disabled="modal.submitDisabled"
                @click="submitSubsectionForm()"
              >Save
              </b-button>
            </div>
            <div class="col text-right">
              <b-button
                size="sm"
                @click="confirmBox()"
                name="delete"
                variant="outline-danger"
              >Delete
              </b-button>
              <b-button size="sm" variant="outline-secondary" @click="cancel('cancel')">
                cancel
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <div class="row" id="subsection_wrap">
        <div class="col-md-6 my-1">
          <b-form-group class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search lessons"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-md-3 col-4 my-1">
          <b-form-group class="mb-0">
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="col-md-3 col-8 my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>

        <div class="col-12">
          <b-table
            bordered
            responsive
            :items="subsections"
            :busy="isBusy"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            sort-icon-left
            class="small"
            show-empty
          >
            <template v-slot:table-busy>
              <div class="text-center my-2 p-2">
                <b-spinner class="align-middle"></b-spinner>
                <br />
                <strong>Loading...</strong>
              </div>
            </template>

            <template v-slot:cell(status)="data">
              <span v-text="arrayElmGet(statuses, data.item.status)"></span>
            </template>

            <template v-slot:cell(description)="data">
              <text-clamp text-class="text-break" :text="data.item.description" />
            </template>

            <template v-slot:cell(main_text)="data">
              <text-clamp text-class="text-break" :html="data.item.main_text" />
            </template>

            <template v-slot:cell(actions)="data">
              <b-dropdown
                size="sm"
                split
                split-variant="outline-primary"
                class="gold"
                text="Edit"
                @click="subsectionEdit($event, data.item)"
              >
                <b-dropdown-item>
                  <div>
                    <a href="#" @click="subsectionEdit($event, data.item)"> Lesson </a>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </div>

        <div class="col-12 my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import BackBtn from '@/components/BackBtn.vue';
import { VueEditor } from 'vue2-editor';
import TextClamp from '@/components/programs/TextClamp.vue';

export default {
  name: 'CoursesSubsectionAdmin',
  components: { BackBtn, VueEditor, TextClamp },
  props: {},
  data() {
    return {
      section_title: '',
      course_id: null,
      modal: {
        title: '',
        submitDisabled: true,
        subsection: {},
        errors: {
          process: '',
        },
      },

      modal_subsection_default: {
        id: 0,
        title: '',
        status: 1,
        section_id: this.$route.params.id,
        video_link: '',
        media: [''],
      },

      statuses: [
        { value: 0, text: 'Closed (deleted)' },
        { value: 1, text: 'Active' },
        { value: 2, text: 'Pending' },
      ],

      errors: {},
      subsections: null,

      fields: [
        { key: 'actions', sortable: false, label: 'Actions', class: '' },
        { key: 'title', sortable: true, label: 'Title', class: '' },
        { key: 'sub_title', sortable: true, label: 'Sub-title', class: '' },
        { key: 'description', sortable: false, label: 'Description', class: '' },
        { key: 'main_text', sortable: false, label: 'Main text', class: '' },
        { key: 'video_link', sortable: false, label: 'Video Link', class: '' },
        { key: 'status', sortable: true, label: 'Status', class: '' },
        { key: 'id', sortable: true, label: 'ID', class: '' },
        { key: 'sort', sortable: true, label: 'Order', class: '' },
      ],
      isBusy: true,
      sortBy: 'sort',
      sortDesc: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 50, text: 'Num to Show' },
        25,
        50,
        100,
        { value: 500, text: 'All' },
      ],
      filter: null,
      filterOn: [],
    };
  },
  methods: {
    arrayElmGet(obj, value) {
      const entries = Object.entries(obj);
      for (const v of entries) {
        if (parseInt(v[1].value) === parseInt(value)) {
          return v[1].text;
        }
      }
      return null;
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this Lesson?')
        .then((value) => {
          if (value == true) {
            this.modal.subsection.status = 0;
            this.submitSubsectionForm();
          } else {
            this.$bvModal.hide('modal-subsection');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    submitSubsectionForm(e) {
      let _this = this;
      if (e) {
        e.preventDefault();
      }

      this.validate(_this.modal.subsection);

      _this.modal.errors.process = 'Processing...';

      let params = new FormData();

      if (_this.modal.subsection) {
        const obj = Object.entries(_this.modal.subsection);
        for (const [k, item] of obj) {
          if (k !== 'media') {
            params.append('subsection[' + k + ']', item);
          }
        }
        const objM = Object.entries(_this.modal.subsection.media);
        for (const [k, item] of objM) {
          params.append('subsection[media][' + k + ']', item);
        }
      }

      const isAdd = !_this.modal.subsection.id || _this.modal.subsection.id === 0;
      const url = '/course-subsections' + (isAdd ? '' : `/${_this.modal.subsection.id}`);

      axios({
        method: isAdd ? 'post' : 'put',
        url: url,
        data: _this.modal.subsection,
      })
        .then(function (response) {
          _this.modal.errors.process = response.data.message;

          if (response.data.status == 1) {
            if (response.data.subsection !== null) {
              if (response.data.action_type == 'add') {
                _this.subsections.unshift(response.data.subsection);
                _this.modal.subsection = _this.modal_subsection_default;
              } else {
                if (_this.modal.subsection.status === 0) {
                  _this.subsections = _this.subsections.filter(
                    (item) => item.id !== _this.modal.subsection.id
                  );
                } else {
                  _this.subsections.find((obj) => {
                    if (obj.id === _this.modal.subsection.id) {
                      obj = response.data.subsection;
                    }
                  });
                }
              }
            }

            _this.totalRows = _this.subsections.length;

            _this.$refs['modal-subsection'].hide();
          } else {
            _this.modal.errors.process = response.data.message;
          }
        })
        .catch(function (e) {
          console.log('Error: submitSubsectionForm:' + e);
        });
    },
    subsectionAdd() {
      this.modal.subsection = { ...this.modal_subsection_default, media: [''], sort: (this.subsections.length + 1) };
      this.modal.title = 'Add Lesson';
      this.modal.errors.process = '';
      this.$bvModal.show('modal-subsection');
      this.validate(this.modal.subsection);
    },
    subsectionEdit(e, item) {
      this.modal.title = 'Edit Lesson';
      this.modal.errors.process = '';
      this.modal.subsection = item;
      this.$bvModal.show('modal-subsection');
      this.validate(this.modal.subsection);
    },
    courseSubsectionsGet() {
      let params = new URLSearchParams();
      params.append('id', this.$route.params.id);
      axios({
        url: 'course-subsections',
        params: params,
      })
        .then((response) => {
          this.isBusy = false;
          if (response.data.status == 1) {
            this.subsections = Object.values(response.data.subsections);
            this.section_title = response.data.title;
          } else {
            this.subsections = [];
            this.section_title = '';
          }
          this.totalRows = this.subsections.length;
        })
        .catch(function () {
          console.log('Error: courseSubsectionsGet.');
        });
    },
    validate(item) {
      var valid = true;
      if (item.status === '' || item.status === 'null') {
        valid = false;
      }
      if (item.title === '') {
        valid = false;
      }

      if (valid == true) {
        this.modal.submitDisabled = false;
        return false;
      } else {
        this.modal.submitDisabled = true;
        return true;
      }
    },
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    active_profile() {
      return this.$store.getters.profileGet;
    },
    user_level() {
      return this.active_profile.level;
    },
  },
  created() {},
  mounted() {
    this.courseSubsectionsGet();
  },
  watch: {},
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  position: relative;
  padding: 0 52px;
}
.page-header h3 {
  min-width: 0;
  text-align: center;
  word-break: break-word;
  font-size: clamp(1rem, 4vw, 1.75rem);
}

</style>
